import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { DeheadingPeelingEntity } from "./deheading-peeling-entity";
import { DeheadingPeelingController } from "./deheading-peeling-controller";
import { DeheadingPeelingService } from "./deheading-peeling-service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { DeheadingPeelingAdapter } from "./dto/deheading-peeling-adapter";
import { DeheadingPeelingLogsEntity } from "./deheading-peeling-logs.entity";

@Module({
    imports:[
        TypeOrmModule.forFeature([DeheadingPeelingEntity,DeheadingPeelingLogsEntity])
    ],
    controllers:[DeheadingPeelingController],
    providers:[DeheadingPeelingService,ApplicationExceptionHandler,LogsService,DeheadingPeelingAdapter],
    exports:[DeheadingPeelingService]
})
export class DeheadingPeelingModule{}